const getContext = (url) => url.split('/cx/')[1];

const getLevels = (context) => context.split('::');

const createContextArray = (levels) =>
    levels.map((lvl) => {
        const state = lvl.split('&');
        return state.reduce((obj, s) => {
            const [key, value] = s.split(':');
            // reset page variable back to 1 to return relevant results
            obj[key] = key === 'page' ? 1 : value;
            return obj;
        }, {});
    });

const getContextArray = (url) => {
    const context = getContext(url);
    const levels = getLevels(context);

    return createContextArray(levels);
};

export {getContextArray};
